import { TLanguage } from "../../types";
import { devMode } from "../debug";

class Bundle {
  private translations: Map<string, string>;

  constructor(
    public readonly lang: TLanguage,
    translations: Record<string, string>,
  ) {
    this.translations = new Map(Object.entries(translations));
  }

  public t(key: string): string {
    if (!this.translations.has(key)) {
      if (devMode) {
        console.error(
          "header-shared-webcomponents is missing",
          this.lang,
          "translation of",
          key,
        );
      }
      return key;
    }
    return this.translations.get(key)!;
  }
}

export type { Bundle };

async function loadBundle(lang: TLanguage) {
  let translations: Record<string, string>;
  switch (lang) {
    case "de":
      translations = (await import("./de.json")).default;
      break;
    case "fr":
      translations = (await import("./fr.json")).default;
      break;
    case "it":
      translations = (await import("./it.json")).default;
      break;
    case "en":
      translations = (await import("./en.json")).default;
      break;
  }

  return new Bundle(lang, translations);
}

const BUNDLES: Partial<Record<TLanguage, Promise<Bundle>>> = {};

export function bundleForLanguage(lang: TLanguage): Promise<Bundle> {
  return (BUNDLES[lang] = BUNDLES[lang] ?? loadBundle(lang));
}
